import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  TelegramIcon,
  LinkedinIcon,
  EmailIcon,
} from 'react-share';

const SocialShare = ({ title, description }) => {
  const location = useLocation();
  const cleanPath = location.pathname.startsWith('/') ? location.pathname.substring(1) : location.pathname;
  const shareUrl = `https://ahobilam.com/api/social-preview/${cleanPath}`;
  const shareTitle = title || "Ahobilam - Vedic Rituals & Services";

  return (
    <div className="flex flex-wrap items-center gap-3 my-6 py-4 border-t border-b border-gray-200">
      <span className="text-sm font-semibold text-gray-700 mr-2">Share this:</span>
      
      <WhatsappShareButton url={shareUrl} title={shareTitle} separator=":: ">
        <WhatsappIcon size={36} round className="hover:scale-110 transition-transform shadow-md" />
      </WhatsappShareButton>

      <FacebookShareButton url={shareUrl} quote={shareTitle}>
        <FacebookIcon size={36} round className="hover:scale-110 transition-transform shadow-md" />
      </FacebookShareButton>

      <TwitterShareButton url={shareUrl} title={shareTitle}>
        <TwitterIcon size={36} round className="hover:scale-110 transition-transform shadow-md" />
      </TwitterShareButton>

      <TelegramShareButton url={shareUrl} title={shareTitle}>
        <TelegramIcon size={36} round className="hover:scale-110 transition-transform shadow-md" />
      </TelegramShareButton>

      <LinkedinShareButton url={shareUrl} title={shareTitle} summary={description} source="Ahobilam.com">
        <LinkedinIcon size={36} round className="hover:scale-110 transition-transform shadow-md" />
      </LinkedinShareButton>

      <EmailShareButton url={shareUrl} subject={shareTitle} body="Check out this page from Ahobilam:">
        <EmailIcon size={36} round className="hover:scale-110 transition-transform shadow-md" />
      </EmailShareButton>
    </div>
  );
};

export default SocialShare;
